import type { RouteObject } from 'react-router-dom';

import { lazy, Suspense } from 'react';

const NotFoundPage = lazy(() =>
  import('./pages/not-found-page').then((m) => ({ default: m.NotFoundPage })),
);

export const notFoundRoutes: RouteObject[] = [
  {
    path: '*',
    element: (
      <Suspense fallback={null}>
        <NotFoundPage />
      </Suspense>
    ),
  },
];
